import { memo } from 'react'
import { Box, Typography } from '@mui/material'

const LoanSelectorHeader = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '20px 0',
    }}
  >
    <div>
      <Typography variant='body1'>Kostenlos & unverbindlich</Typography>
      <Typography variant='h4'>
        Günstige Kredite - garantiert! <br /> Erfahren Sie Ihre persönliche
        Monatsrate
      </Typography>
    </div>
  </Box>
)

export default memo(LoanSelectorHeader)
